import { render, staticRenderFns } from "./discography.vue?vue&type=template&id=01a19ff6&scoped=true&"
import script from "./discography.vue?vue&type=script&lang=js&"
export * from "./discography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a19ff6",
  null
  
)

export default component.exports